export const GRADES_LIST_REQUEST = 'GRADES_LIST_REQUEST';
export const GRADES_LIST_SUCCESS = 'GRADES_LIST_SUCCESS';
export const GRADES_LIST_FAIL = 'GRADES_LIST_FAIL';